import {
  requestPackList,
  requestPackDetail,
  requestPackCardList,
  requestSavePackPassword,
  requestAllPackList,
  requestCheckPack,
  requestBuyPack,
  requestGachaResult,
  requestBuyPackResult,
  requestDividePackCard,
  requestPostPackList,
} from '@/api/pack';

const state = {
  packList: null,
  packCardList: null,
  currentPack: null,
  packCheckResult: null,
  savePackPassword: null,
  buyPackResult: null,
  devidePackCardresult: null,
  topCardType: 999996,
  currentPackHistory: {},
  isFromShop: false,
};

const getters = {
  packList: (state) => state.packList,
  packCardList: (state) => state.packCardList,
  currentPack: (state) => state.currentPack,
  packCheckResult: (state) => state.packCheckResult,
  savePackPassword: (state) => state.savePackPassword,
  buyPackResult: (state) => state.buyPackResult,
  devidePackCardresult: (state) => state.devidePackCardresult,
  topCardType: (state) => state.topCardType,
  currentPackHistory: (state) => state.currentPackHistory,
  isFromShop: (state) => state.isFromShop,
};

const actions = {
  async setPackList({ commit, dispatch }, { categoryId = '', url = '' }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestPackList({ categoryId, url });
    commit('setPackList', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async setPackCardList({ commit, dispatch }, { pageNumber, packId }) {
    await dispatch('setIsLoading', true, { root: true });
    commit('setPackCardList', null);
    const result = await requestPackCardList({ pageNumber, packId });
    commit('setPackCardList', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async setPostPackList({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    commit('setPackList', null);
    console.log(postParams);
    const result = await requestPostPackList({ csrfToken, postParams });
    commit('setPackList', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    await dispatch('setIsLoading', false, { root: true });
  },
  async clearPackCardList({ commit }) {
    commit('setPackCardList', null);
  },
  async setAllPackList({ commit, dispatch }, { pageNumber, type }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestAllPackList({ pageNumber, type });
    commit('setPackList', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async setCurrentPack({ commit, dispatch }, { packId }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestPackDetail({ packId });
    commit('setCurrentPack', result.data.detail);
    await dispatch('setIsLoading', false, { root: true });
  },
  clearCurrentPack({ commit }) {
    commit('setCurrentPack', null);
  },
  async setCheckPackResult({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestCheckPack({ csrfToken, postParams });
    commit('setCheckPackResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  clearPackCheckResult({ commit }) {
    commit('setCheckPackResult', null);
  },
  async setSavePackPassword({ commit, dispatch, rootGetters }, { postParams }) {
    console.log('aaa');
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestSavePackPassword({ csrfToken, postParams });
    commit('setSavePackPassword', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  clearSavePackPassword({ commit }) {
    commit('setSavePackPassword', null);
  },
  async buyPack({ commit, dispatch, rootGetters }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestBuyPack({ csrfToken });
    commit('setBuyPackResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  clearBuyPackResult({ commit }) {
    commit('setBuyPackResult', null);
  },
  async setGachaResult({ commit, dispatch }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestGachaResult();
    commit('setBuyPackResult', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async setBuyPackResult({ commit, dispatch }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestBuyPackResult();
    commit('setBuyPackResult', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async devidePackCard({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestDividePackCard({ csrfToken, postParams });
    commit('setDevidePackCardResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  clearDevidePackCardResult({ commit }) {
    commit('setDevidePackCardResult', null);
  },
  setTopCardType({ commit }, cardType) {
    commit('setTopCardType', cardType);
  },
};

const mutations = {
  setPackList(state, packList) {
    state.packList = packList;
  },
  setPackCardList(state, packCardList) {
    state.packCardList = packCardList;
  },
  setCurrentPack(state, currentPack) {
    state.currentPack = currentPack;
  },
  setCheckPackResult(state, packCheckResult) {
    state.packCheckResult = packCheckResult;
  },
  setSavePackPassword(state, savePackPassword) {
    state.savePackPassword = savePackPassword;
  },
  setBuyPackResult(state, buyPackResult) {
    state.buyPackResult = buyPackResult;
  },
  setDevidePackCardResult(state, devidePackCardresult) {
    state.devidePackCardresult = devidePackCardresult;
  },
  setTopCardType(state, cardType) {
    state.topCardType = cardType;
  },
  setIsFromShop(state, isFromShop) {
    state.isFromShop = isFromShop;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
